import React from 'react';
import { useTranslation } from 'react-i18next';
import DownloadOutlinedIcon from '@mui/icons-material/DownloadOutlined';
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import SaveOutlinedIcon from '@mui/icons-material/SaveOutlined';
import CreateNewFolderOutlinedIcon from '@mui/icons-material/CreateNewFolderOutlined';

import CollapsedButton, {
  COLLAPSED_BUTTON_SIZES,
  COLLAPSED_BUTTON_TYPES,
} from '../../../components/collapsed-button/CollapsedButton';
import { LOADING_TYPES } from '../media-card/MediaCard';

import scss from './CardActions.module.scss';

function CardActions({
  id,
  mediaType,
  fileName,
  onDownload,
  onRemove,
  onSaveToBucket,
  loadingState,
  onCreateNewBucket,
  additionalCardActions,
}) {
  const { t } = useTranslation('studio');

  const handleDownload = () => {
    onDownload(id);
  };

  const handleRemove = async () => {
    await onRemove(id);
  };

  const handleSaveToBucket = async () => {
    await onSaveToBucket(id);
  };

  const handleCreateNewBucket = async () => {
    await onCreateNewBucket(id);
  };

  return (
    <div className={scss.actions}>
      <CollapsedButton
        type={COLLAPSED_BUTTON_TYPES.TABLE_ROW}
        size={COLLAPSED_BUTTON_SIZES.MEDIUM}
        onClick={handleDownload}
        icon={DownloadOutlinedIcon}
        label={t('download')}
      />
      {additionalCardActions.map((action) => (
        <CollapsedButton
          key={action.label}
          type={action.type}
          size={action.size}
          onClick={() => action.onClick({ id, mediaType, fileName })}
          icon={action.icon}
          label={action.label}
          isLoading={action.isLoading}
        />
      ))}

      {onCreateNewBucket ? (
        <CollapsedButton
          type={COLLAPSED_BUTTON_TYPES.PRIMARY}
          size={COLLAPSED_BUTTON_SIZES.MEDIUM}
          onClick={handleCreateNewBucket}
          isLoading={loadingState.includes(LOADING_TYPES.CREATING_NEW_BUCKET)}
          icon={CreateNewFolderOutlinedIcon}
          label={t('createNewBucket')}
        />
      ) : null}
      {onSaveToBucket ? (
        <CollapsedButton
          type={COLLAPSED_BUTTON_TYPES.PRIMARY}
          size={COLLAPSED_BUTTON_SIZES.MEDIUM}
          onClick={handleSaveToBucket}
          isLoading={loadingState.includes(LOADING_TYPES.SAVING_TO_BUCKET)}
          icon={SaveOutlinedIcon}
          label={t('saveToBucket')}
        />
      ) : null}
      <CollapsedButton
        type={COLLAPSED_BUTTON_TYPES.DANGER}
        size={COLLAPSED_BUTTON_SIZES.MEDIUM}
        onClick={handleRemove}
        isLoading={loadingState.includes(LOADING_TYPES.REMOVING_MEDIA)}
        icon={DeleteOutlinedIcon}
        label={t('remove')}
      />
    </div>
  );
}

export default CardActions;
